<template>
  <div id="faq">
    <audio autoplay ref="faqsAudio"></audio>
    <md-list :md-expand-single="expandSingle">
      <md-list-item md-expand :md-expanded.sync="isBrahmaSamhitaExpanded" 
        @click="play('brahma-samhita')"
      >
        <md-icon>whatshot</md-icon>
        <span class="md-list-item-text">{{ translate('who-is-krishna') }}</span>

        <md-list slot="md-expand">
          <md-list-item class="md-inset">

            <span v-html="translate('krishna-explained')" style="margin: auto;"> </span>

          </md-list-item>
        </md-list>

      </md-list-item>

      <md-list-item md-expand :md-expanded.sync="isBgExplainedExpanded" 
        @click="play('bg-explained')"
      >
        <md-icon>book</md-icon>
        <span class="md-list-item-text"> {{ translate('whats-the-bhagavad-gita') }} </span>

        <md-list slot="md-expand">
          <span style="margin: auto;" v-html="translate('bg-explained')">

          </span>
        </md-list>
      </md-list-item>

      <md-list-item md-expand :md-expanded.sync="isIskconPreceptsExpanded" @click="play('iskcon-precepts')">
        <md-icon>video_library</md-icon>
        <span class="md-list-item-text"> {{ translate('whats-the-hk-movement') }} </span>

        <md-list slot="md-expand" style="white-space: normal;">
          <a href="https://en.wikipedia.org/wiki/International_Society_for_Krishna_Consciousness"
            target="_blank"
          >
            {{ translate('explain-iskcon') }}
          </a>
          <small v-if="this.viewPortWidth < 768"> {{ translate('click-to-open') }} </small>
          <br>
          <a href="http://www.krishna.com/seven-purposes-iskcon-0" target="_blank">
            <span v-html="translate('iskcon-goals-statement')"></span>
          </a>
        </md-list>
      </md-list-item>


    </md-list>
  </div>
</template>

<script>
  import { eventBus } from '../main.js'
  import mixins from '../assets/mixins.js'
  export default {
    name: 'faqs',
    mixins: [mixins],
    mounted() {

      // this.$route.params.lang ? this.lang = this.$route.params.lang : null
      eventBus.$on('updateLanguage', this.setLang)

      // window.onresize = () => {
      //   this.viewPortWidth = window.innerWidth
      // }
    },
    computed: {
     /* language() {
        if (this.lang) {
          return this.lang
        } else {
          this.checkLanguage()
        }
        return this.lang */
    },
    data() {
      return {
        viewPortWidth: window.innerWidth,
        isIskconPreceptsExpanded: false,
        isBrahmaSamhitaExpanded: false,
        isBgExplainedExpanded: false,
        expandSingle: true,
        lang: null,
      }
    },
    methods: {

      checkWidth() {
        return window.innerWidth < 551 ? '<br>' : ''
      },

      play(which) {
        switch (which) {
          case 'brahma-samhita':

            setTimeout(() => {

              if (this.isBrahmaSamhitaExpanded) {

                this.$refs.faqsAudio.onpause = () => {
                  if (this.$refs.faqsAudio && this.$refs.faqsAudio.src.indexOf('translation') === -1) {
                    if (this.language === 'pt') {
                      this.$refs.faqsAudio.src = 'audio/faq/brahma_samhita/sri_bs_5_1-translation-pt.m4a'
                    } else {
                      this.$refs.faqsAudio.src = 'audio/faq/brahma_samhita/sri_bs_5_1-translation-en.m4a'
                    }
                  }
                }
                if (this.$refs.faqsAudio.paused || this.$refs.faqsAudio.src.indexOf('sri_brahma_samhita_5_1') === -1) {
                  this.$refs.faqsAudio.src = 'audio/faq/brahma_samhita/sri_brahma_samhita_5_1.m4a'
                }

              } else {
                this.$refs.faqsAudio.onpause = null
                this.$refs.faqsAudio.pause()
              }

            }, 100)

            break

          case 'bg-explained':

            this.$refs.faqsAudio.onpause = null

            setTimeout(() => {

              if (this.isBgExplainedExpanded) {

                if (this.$refs.faqsAudio.paused ||
                  this.$refs.faqsAudio.src.indexOf('faq2_bg_explained') === -1) {

                  if (this.language === 'pt') {
                    this.$refs.faqsAudio.src = 'audio/faq/bg_explained/faq2_bg_explained-pt.m4a'
                  } else {
                    this.$refs.faqsAudio.src = 'audio/faq/bg_explained/faq2_bg_explained-en.m4a'
                  }
                }

              } else {
                this.$refs.faqsAudio.pause()
              }

            }, 100);

            break

          case 'iskcon-precepts':

            this.$refs.faqsAudio.onpause = null

            setTimeout(() => {

              this.$refs.faqsAudio.onpause = () => {
                if (this.$refs.faqsAudio.src.indexOf('iskcon_precepts-1-') > -1) {
                  if (this.language === 'pt') {
                    this.$refs.faqsAudio.src = 'audio/faq/iskcon_precepts/iskcon_precepts-2-pt.m4a'
                  } else {
                    this.$refs.faqsAudio.src = 'audio/faq/iskcon_precepts/iskcon_precepts-2-en.m4a'
                  }
                }
              }

              if (this.isIskconPreceptsExpanded) {

                if (this.$refs.faqsAudio.paused ||
                  this.$refs.faqsAudio.src.indexOf('iskcon_precepts') === -1) {

                  if (this.language === 'pt') {
                    this.$refs.faqsAudio.src = 'audio/faq/iskcon_precepts/iskcon_precepts-1-pt.m4a'
                  } else {
                    this.$refs.faqsAudio.src = 'audio/faq/iskcon_precepts/iskcon_precepts-1-en.m4a'
                  }
                }

              } else {
                this.$refs.faqsAudio.pause()
              }

            }, 100);

            break

          default: break
        }
      },

      // setLang(l) {
      //   this.lang = l
      // },

      translate(section) {
        switch (section) {
          case 'visit-our-temples':
            if (this.language === 'pt')
              return 'Visite nossos projetos'
            else
              return 'Visit our temples'

          case 'who-is-krishna':
            if (this.language === 'pt')
              return 'Quem é Krishna?'
            else
              return 'Who is Krishna?'

          case 'krishna-explained':
            const sanskrit = `<h3> Śrī brahma-saṁhitā 5.1 </h3> <a href="https://vedabase.io/en/library/bs/5/1/" target="_blank"> <em>īśvaraḥ paramaḥ kṛṣṇaḥ<br>sac-cid-ānanda-vigrahaḥ<br>anādir ādir govindaḥ<br>sarva-kāraṇa-kāraṇam</em> </a> <br>`
            let translation
            if (this.language === 'pt')
              translation = '<small> Clique no verso-sanskrito para abrir o link </small> <h2>Tradução</h2> <p> <strong> Kṛṣṇa, que é conhecido como <br> Govinda, é o Deus Supremo. <br> Ele tem um corpo espiritual <br> eterno e pleno de bem-aventurança. <br> Ele é a origem de todos. <br> Ele é o começo sem começo <br> e a causa de todas as causas. </strong> </p>'
            else
              translation = '<small> Click the sanskrit-verse to open the link </small> <h2>Translation</h2> <p> <strong> Kṛṣṇa who is known as <br> Govinda is the Supreme Godhead. <br> He has an eternal blissful <br> spiritual body. He is the origin of all. <br> He has no other origin and <br> He is the prime cause of all causes. </strong> </p>'
            return sanskrit + translation

          case 'whats-the-bhagavad-gita':
            if (this.language === 'pt')
              return 'O que é o Bhagavad-gita?'
            else
              return 'What is the Bhagavad-gita?'

          case 'bg-explained':

            if (this.language === 'pt')
              return `<a href="https://vedabase.io/pt-br/library/bg/" target="_blank"><p> Os temas cobertos no Bhagavad Gita ${this.checkWidth()} explicam a ciência de Deus em cinco ${this.checkWidth()} verdades básicas: </p> <ol> <li>Quem é O Controlador ${this.checkWidth()} \'Deus\' - [Isvara]</li> <li>As entidades vivas [jivas]</li> <li>Natureza Material [prakrti]</li> <li>Tempo [kala, a duração de ${this.checkWidth()} existência do universo]</li> <li>Atividade, trabalho [karma]</li> </ol></a> <small> Clique para abrir o link </small>`
            else
              return `<a href="https://vedabase.io/en/library/bg/" target="_blank"> <p> The subject matter of Bhagavad Gita ${this.checkWidth()} explains the science of God by covering ${this.checkWidth()} five basic truths: </p> <ol> <li>Who is The Controller ${this.checkWidth()} \'God\' - [Isvara]</li> <li>The living entities [jivas]</li> <li>Material Nature [prakrti]</li> <li>Time [kala, the duration of the ${this.checkWidth()} existence of the universe]</li> <li>Activity, work [karma]</li> </ol></a> <small> Click to open the link </small>`

          case 'whats-the-hk-movement':
            if (this.language === 'pt')
              return 'O que é o movimento Hare Krishna?'
            else
              return 'Whats the Hare Krishna movement?'

          case 'explain-iskcon':
            if (this.language === 'pt')
              return 'A Sociedade Internacional para a Consciência de Krishna (ISKCON), conhecida coloquialmente como o movimento Hare Krishna ou Hare Krishnas, é uma organização religiosa hindu Gaudiya Vaishnava. A ISKCON foi fundada em 1966 na cidade de Nova York por A. C. Bhaktivedanta Swami Prabhupada. Suas crenças centrais são baseadas nas escrituras, o Bhagavad Gita e o Bhagavata Purana, e na tradição Gaudiya Vaishnava, que tem adeptos na Índia desde o final do século XV e devotos americanos e europeus desde o início do século XX.'
            else
              return 'The International Society for Krishna Consciousness (ISKCON), known colloquially as the Hare Krishna movement or Hare Krishnas, is a Gaudiya Vaishnava Hindu religious organisation. ISKCON was founded in 1966 in New York City by A. C. Bhaktivedanta Swami Prabhupada. Its core beliefs are based on scriptures, the Bhagavad Gita and the Bhagavata Purana, and the Gaudiya Vaishnava tradition, which has had adherents in India since the late 15th century and American and European devotees since the early 1900s.'

          case 'iskcon-goals-statement':
            if (this.language === 'pt')
              return '<h2>Os principais preceitos do Movimento</h2> <ol> <li>Propagar o conhecimento espiritual na sociedade e educar todas as pessoas nas técnicas da vida espiritual a fim de sustar o desequilíbrio de valores na vida e alcançar a verdadeira unidade e paz mundiais;</li> <li>Propagar a consciência de Krishna, como é revelada no Bhagavad-gita e no Srimad Bhagavatam;</li> <li>Ensinar e encorajar o movimento de sankirtana, canto congregacional dos santos nomes de Deus, conforme é revelado nos ensinamentos do Senhor Sri Caitanya Mahaprabhu;</li> <li>Erigir, para os membros e para a sociedade em geral, um lugar sagrado de passatempos transcendentais, dedicado à Personalidade de Krishna;</li> <li>Manter em todos o objetivo de ensinar um modo de vida mais simples e natural;</li> <li>Publicar e distribuir periódicos, revistas, livros e outros escritos.</li>  </ol>'
            else
              return '<h2>The main precepts of the Movement</h2> <ol> <li>Propagate spiritual knowledge in society and educate all people in the techniques of spiritual life in order to overcome the imbalance of values ​​in life and to achieve true world unity and peace;</li> <li>Propagate Krishna consciousness, as revealed in Bhagavad-gita and Srimad Bhagavatam;</li> <li>To unite members of society with each other and bring them closer to Krishna, the primary entity, in order to develop the idea, among members and humanity in general, that each soul is an integral part of the quality of God;</li> <li>Teach and encourage the sankirtana movement, the congregational chant of the holy names of God, as revealed in the teachings of Lord Sri Caitanya Mahaprabhu;</li> <li>To erect, for the members and for the society in general, a sacred place of transcendental pastimes, dedicated to the Personality of Krishna;</li> <li>Maintain in everyone the objective of teaching a simpler and more natural way of life;</li> <li>Publish and distribute periodicals, magazines, books and other writings;</li> </ol>'

          case 'click-to-open':
            if (this.language === 'pt')
              return 'Clique no texto para abrir o link'
            else
              return 'Click the text to open the link'

        }
      },
    }
  }
</script>

<style>
  .md-list-item.md-inset .md-list-item-content {
    padding: 22px;
  }

  .md-list-item-text {
    white-space: pre-wrap;
  }
</style>